export default __webpack_public_path__ + "static/media/check.c2da292e.svg";